import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/closeBtn.png'
import _imports_1 from '@/assets/eventModalLogo.png'
import _imports_2 from '@/assets/eventModalLogo_wh.png'


const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "event_content_wrap" }
const _hoisted_3 = { class: "bottom" }
const _hoisted_4 = {
  key: 0,
  class: "logo",
  src: _imports_1,
  alt: ""
}
const _hoisted_5 = {
  key: 1,
  class: "logo",
  src: _imports_2,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Event = _resolveComponent("Event")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer find_account",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["pop_detail event_pop_up speak_campaign", {
            mobile: $setup.state.isMobile,
            main: $setup.state.step === 0,
            content: $setup.state.step > 0 && $setup.state.step < 4,
            comment: $setup.state.step === 4,
            complete: $setup.state.step > 4,
        }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString($setup.props.title), 1),
        _createElementVNode("button", {
          class: "close_btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Event, {
          step: $setup.state.step,
          "onUpdate:step": _cache[2] || (_cache[2] = ($event: any) => (($setup.state.step) = $event)),
          onComplete: $setup.complete
        }, null, 8, ["step", "onComplete"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        ($setup.state.step === 0 || $setup.state.step === 4)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : (_openBlock(), _createElementBlock("img", _hoisted_5))
      ])
    ], 2)
  ], 64))
}